import React, { useState } from 'react';

import Logoonly from '../clublogoonly.png';
import newLogo from "../club-transparentlogo.png";
import clientclublogo from '../logo/Belur.jpeg';

function Logoloder() {
    // const [loader, setLoader] = useState(true);
    return (
        <div style={{ display: true ? "block" : "none" }}>
            <div class="loading">
                <div>
                    <div class="loaderClass">
                        {/* <img src={Logoonly} alt="logoImage" /> */}
                        <img src={clientclublogo} alt="logoImage"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Logoloder;
